import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/providers/general/general.service';
import { OrganisationService } from 'src/app/providers/setups/organisation/organisation.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import { SysLogsComponent } from '../sys-logs/sys-logs.component';
declare let $: any;
@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {
  @Input() entitytypeid;
  @Input() sourceid;
  @Input() config;
  @Input() empName;
  @Input() logTable: any;
  @ViewChild(SysLogsComponent) sysLogs: SysLogsComponent;
  @Output() callSyslogsAddress = new EventEmitter<string>();
// this.empLogsAdd();
  // @Input() myAddress;
  myAddress: any = [];
  response: any = [];
  response1: any = [];
  addressForm: FormGroup;
  subAdd = false;
  loading;
  myRegion: any = [];
  myState: any = [];
  country: any = [];
  myDivision: any = [];
  myCity: any = [];
  myPincode: any = [];
  editResponse: any = [];
  dynamicHeader: any;

  constructor(
    private formBuilder: FormBuilder,
    public httpOrg: OrganisationService,
    private genhttp: GeneralService,
    private notifyService: NotificationService) {
     }

  ngOnInit(): void {
    this.AddressFormField();
    this.getCountry();
    this.getEntityAddress();
    // console.log('emp name -', this.empName);
  }
  empLogsAdd(): void {
    this.callSyslogsAddress.emit('');
  }
  AddressFormField(): void {
    this.addressForm = this.formBuilder.group({
      add_id: [''],
      person_name: ['', Validators.required],
      cn_id: ['', Validators.required],
      // rgn_id: ['', Validators.required],
      st_id: ['', Validators.required],
      // dvsn_id: ['', Validators.required],
      city_id: ['', Validators.required],
      addline_1: ['', Validators.required],
      addline_2: [''],
      addline_3: [''],
      pincode: ['', Validators.required],
      source_id: [],
      entity_type_id: [],
      table : [],
      isPrimary: ['1', Validators.required]
    });
  }

  // tslint:disable-next-line: typedef
  get addErrorMsg() { return this.addressForm.controls; }

  addAddress(id , header): void {
    // console.log(this.empName);
    // console.log(this.sourceid);
    // console.log(this.entitytypeid);
    this.subAdd = false;
    this.addressForm.patchValue({
      person_name: this.empName,
      source_id: this.sourceid,
      entity_type_id: this.entitytypeid,
      table : this.logTable
    });
    this.dynamicHeader = header ;
    // this.AddressFormField();
    $(id).modal({backdrop: 'static' , keyboard: false});
  }

  getEntityAddress(): void {
    this.genhttp.getEntityAddress(this.entitytypeid, this.sourceid).subscribe(data => {
      this.response1 = data;
      if (this.response1.status === false) {
      } else if (this.response1.status === true) {
        this.myAddress = this.response1.data;
        // this.Logs = this.response1.data.syslogs;
      }

    });
  }

  deleteAddress(id): void {
    this.genhttp.delAddress(id).subscribe(data => {
      console.log(data);
      this.response = data;
      if (this.response.status === false) {
        this.notifyService.showSuccess(this.response.msg, 'Info!');
      } else if (this.response.status === true) {
        this.notifyService.showSuccess(this.response.msg, 'Success!');
        this.myAddress = this.myAddress.filter(val => val.add_id !== id );
        this.empLogsAdd();
      }
    });
  }

  onSubmitAddress(): void {
    this.subAdd = true;
    console.log(this.addressForm);
    // return;
    if (this.addressForm.invalid) {
      return;
    } else {
      this.httpOrg.addAddress(this.addressForm.value).subscribe(data => {
        this.response = data;
        if (this.response.status === true) {
          this.notifyService.showSuccess(this.response.msg, 'Success !');
          this.addressForm.reset();
          this.addressForm.patchValue({
            entity_type_id :  this.entitytypeid
          });
          this.empLogsAdd();
        } else {
          this.notifyService.showError(this.response.msg, 'Error !');
        }
        $('#zero_add_address').modal('hide');
        this.getEntityAddress();
        // if (this.response.status === false) {
        //   alert(this.response.msg);
        //   this.notifyService.showInfo(this.response.msg, 'Info!');
        // } else if (this.response.status === true) {
        //   this.notifyService.showSuccess(this.response.msg, 'Success!');
        //   $('#zero_add_address').modal('hide');
        //   this.getEntityAddress();
        // } else {

        // }
      }, err => {
        this.notifyService.showError(err.error.msg, 'Error !');
      });
    }
  }

  onResetaddress(): void {
    this.AddressFormField();
  }

  onChangeCountry(ev): void {
    console.log('sta call' + ev.value);
    // this.getCountryRegion(ev.value);
    this.getState(ev.value);
  }

  getCountry(): void {
    this.genhttp.getCountry().then(data => {
      console.log(data);
      this.response = data;
      if (this.response.status === false) {
        this.country = [{label: 'No Data Found', value: '', disabled: true}];
      } else if (this.response.status === true) {
        this.country = this.response.data;
      }
    });
  }

  // getCountryRegion(id): void {
  //   this.genhttp.getCountryRegion(id).then(data => {
  //     console.log(data);
  //     this.response = data;
  //     if (this.response.status === false) {

  //     } else if (this.response.status === true) {
  //       this.myRegion = this.response.data;
  //     }
  //     this.getState(id);
  //   });
  // }

  getState(id): void {
    this.genhttp.getCountryState(id).then(data => {
      this.response = data;
      console.log(this.response);
      if (this.response.status === false) {
        this.myState = [{label: 'No Data Found' , value: '', disabled: true }];
      } else if (this.response.status === true) {
        this.myState = this.response.data;
      }
    });
  }

  onChangeState(ev): void {
    this.genhttp.getCountryCity(ev.value).then(data => {
      console.log(data);
      this.response = data;
      if (this.response.status === false) {
        this.myCity = [{label: 'No Data Found', value: '', disabled: true}];
      } else if (this.response.status === true) {
        this.myCity = this.response.data;
      }
      // this.getDivision(ev.value);
    });
  }

  // getDivision(id): void {
  //   this.genhttp.getCountryDivision(id).then(data => {
  //     this.response = data;
  //     if (this.response.status === false) {

  //     } else if (this.response.status === true) {
  //       this.myDivision = this.response.data;
  //     }
  //   });
  // }

  // onChangeCity(ev): void {
  //   this.genhttp.getCountryPincode(ev.value).then(data => {
  //     this.response = data;
  //     if (this.response.status === false) {

  //     } else if (this.response.status === true) {
  //       this.myPincode = this.response.data;
  //     }
  //   });
  // }

  editAddress(addid , header): void {
    this.subAdd = false;
    this.dynamicHeader = header;
    this.httpOrg.editAddress(addid).subscribe(data => {
      console.log(data);
      this.response = data;
      if (this.response.status === false) {
        alert(this.response.msg);
      } else if (this.response.status === true) {
        this.getMaster(this.response.data);
      } else {

      }
    });
  }

  getMaster(data): void {
    console.log(data);
    // this.genhttp.getCountry().then(getCoun => {
    //   this.response = getCoun;
    //   if (this.response.status === true) {
    //     this.country = this.response.data;
    //   }
    // });
    this.getMasterState(data);
  }

  getMasterState(data): void {
    this.genhttp.getCountryState(data.cn_id).then(genState => {
      this.response = genState;
      if (this.response.status === true) {
        this.myState = this.response.data;
      }
      this.getMasterCity(data);
      // this.getMasterRegion(data);
    });
  }

  // getMasterRegion(data): void {
  //   this.genhttp.getCountryRegion(data.cn_id).then(genReg => {
  //     this.response = genReg;
  //     if (this.response.status === true) {
  //       this.myRegion = this.response.data;
  //     }
  //     this.getMasterDivision(data);
  //   });
  // }

  // getMasterDivision(data): void {
  //   this.genhttp.getCountryDivision(data.st_id).then(genDivision => {
  //     this.response = genDivision;
  //     if (this.response.status === true) {
  //       this.myDivision = this.response.data;
  //     }
  //     this.getMasterCity(data);
  //   });
  // }

  getMasterCity(data): void {
    this.genhttp.getCountryCity(data.st_id).then(genCity => {
      this.response = genCity;
      if (this.response.status === true) {
        this.myCity = this.response.data;
      }
      this.getMasterPincode(data);
    });
  }

  getMasterPincode(data): void {
    this.genhttp.getCountryPincode(data.ct_id).then(genPin => {
      this.response = genPin;
      if (this.response.status === true) {
        this.myPincode = this.response.data;
      }
      // tslint:disable-next-line: triple-equals
      const isPrimary = data.is_primary == 1 ? 1 : 0;
      this.addressForm.patchValue({
        person_name: data.add_person_name,
        cn_id: data.cn_id,
        // rgn_id: data.rgn_id,
        st_id: data.st_id,
        city_id: data.ct_id,
        pincode: data.pincode_id,
        // dvsn_id: data.dvsn_id,
        addline_1: data.add_line1,
        addline_2: data.add_line2,
        addline_3: data.add_line3,
        source_id: this.sourceid,
        entity_type_id :  this.entitytypeid,
        add_id: data.add_id,
        table : this.logTable,
        isPrimary
      });
      setTimeout(() => {
        this.addressForm.patchValue({
          st_id: data.st_id,
          city_id: data.ct_id,
        });
      }, 2000);
      console.log(this.addressForm.value);
      $('#zero_add_address').modal('show');
    });
  }

}
